import React from 'react';
import { Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

export const WhenFieldChangesSetAnotherField = ({ field, becomes, set, to }) => (
  // set: name of field to be modified
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <FormSpy subscription={{}}>
        {({ form }) => (
          // field: field that causes the modification
          <OnChange name={field}>
            {value => {
              // becomes: comparison value to value (of field). value is not a parameter
              if (becomes && value === becomes) {
                // to: value we want to set "set" to.
                onChange(to);
              } else {
                // if no compare value is sent, it will always change
                onChange(to);
              }
            }}
          </OnChange>
        )}
      </FormSpy>
    )}
  </Field>
);

export const WhenFieldChangesDo = ({ field, set, becomes, action }) => (
  // field es el campo que cambia
  // becomes es el valor de field
  // set es el campo que queremos cambiar
  // action es la funcion que ejecuta lo que queremos hacer antes de cambiar el campo set
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <FormSpy subscription={{ values: true }}>
        {({ form }) => (
          <OnChange name={field}>
            {value => {
              action({ onChange, field, value, becomes, set });
            }}
          </OnChange>
        )}
      </FormSpy>
    )}
  </Field>
);

export const SetMetaDataField = ({ field, meta, mutators: { setFieldData } }) => (
  <FormSpy
    subscription={{ values: true }}
    onChange={({ values }) => {
      setFieldData(field, meta);
    }}
  />
);